import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { Button } from '@sbt-web/ui';
import styles from '../index.module.scss';
export interface BuyNowButtonProps {
  onClick: () => void;
  classes?: string[];
}
export const BuyNowButton = t0 => {
  const $ = _c(7);
  const {
    onClick,
    classes
  } = t0;
  let t1;
  if ($[0] !== classes) {
    t1 = classnames(classes, styles["buy-now-button"]);
    $[0] = classes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClick || $[5] !== t2) {
    t3 = <Button classes={t2} size="large" onClick={onClick} design="solid">Acquista</Button>;
    $[4] = onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};